import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { slices } from '~/redux/slices';
import { calcPercentage } from '~/utils/calcPercentage';

export const useCreditStatusMessage = () => {
  const intl = useIntl();
  const creditsSummary = useSelector(
    slices.xRay.selectors.selectCreditsSummary,
  );

  const creditsUsed = creditsSummary
    ? calcPercentage(
        creditsSummary.totalCredits - creditsSummary.credits,
        creditsSummary.totalCredits,
      )
    : 0;

  if (creditsSummary) {
    return creditsSummary.credits <= 0
      ? {
          message: intl.formatMessage({
            id: 'useCreditStatusMessage.contactEvisortForCredits',
            defaultMessage:
              'Contact Evisort to purchase additional credits. You may be invoiced for the negative credit balance at the Credit overage rate.',
            description:
              'Message when credits are exhausted and user has negative balance',
          }),
          status: 'danger' as const,
          title: intl.formatMessage({
            id: 'useCreditStatusMessage.allCreditsUsed',
            defaultMessage: 'You have used up all of your available credits.',
            description: 'Title when all credits have been used',
          }),
        }
      : creditsUsed && creditsUsed >= 90
        ? {
            message: intl.formatMessage({
              id: 'useCreditStatusMessage.contactEvisortMessage',
              defaultMessage: 'Contact Evisort to purchase additional credits.',
              description: 'Message to contact Evisort for more credits',
            }),
            status: 'danger' as const,
            title: intl.formatMessage({
              id: 'useCreditStatusMessage.ninetyPercentUsed',
              defaultMessage:
                'You used more than 90% of your available credits.',
              description: 'Title when more than 90% of credits are used',
            }),
          }
        : undefined;
  }
};
